import { gateTransportWrites } from "./gateTransportWrites";
import { type AskV2TransportApi } from "./useAskV2Transport";

/**
 * Gate once, at the transport, rather than at each render site: the review
 * workspace mounts its own `AskV2Thread` out of this same transport, so a
 * `readOnly` prop on the page's own thread would never reach that surface.
 *
 * `canInteract` fails OPEN (`?? true`): the flag is absent on older/cached
 * payloads, and the lock may only engage on the server's explicit say-so.
 * Read a locked composer as an affordance, not as proof the server refused —
 * see `gateTransportWrites` for the routes this gate does and does not reach.
 */
export function useAskV2Interactivity(transport: AskV2TransportApi): {
  canInteract: boolean;
  gatedTransport: AskV2TransportApi;
} {
  const canInteract = transport.historyChat?.canInteract ?? true;
  const gatedTransport = gateTransportWrites(transport, canInteract);
  return { canInteract, gatedTransport };
}
